import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <div className="Footer">
      <footer className="credits">
        Coded by{" "}
        <a href="https://github.com/SoleaMD/my-weather-react">
          SoleaMD
        </a>
      </footer>
    </div>
  );
}
